import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import { WorkItemControl } from "WorkItemTracking/Scripts/Controls/WorkItemForm/WorkItemControl";
import { AssociatedAutomationControl } from "../Controls/TFS.TestManagement.AssociatedAutomationControl";

export interface IAssociatedAutomationProps {
    workItem: any;
}

/// <reference types="jquery" />

// This is a proxy component to load the edit test case(s) dialog using LegacyComponent
class AssociatedAutomationProxy extends React.Component<IAssociatedAutomationProps> {
    private _container: HTMLDivElement;
    private _control: WorkItemControl;

    public render(): React.ReactNode {
        if (this._control !== undefined) {
            this._control.bind(this.props.workItem);
        }
        return <div ref={this._resolveContainerRef}></div>;
    }

    public componentDidMount(): void {
        this._renderControl();
    }

    public componentWillUnmount(): void {
        this._disposeFieldControl();
    }

    private _renderControl(): void {
        this._disposeFieldControl();

        const $controlContainer = $(this._container);

        const associatedAutomationControl: AssociatedAutomationControl = new AssociatedAutomationControl($controlContainer);
        this._control = associatedAutomationControl;
        // Let the control know it's being used within react
        this._control.bind(this.props.workItem);
    }

    private _disposeFieldControl(): void {
        if (this._control) {
            this._control.unbind();
            this._control.dispose();
            this._control = null;
        }
    }

    private _resolveContainerRef = (element: HTMLDivElement): void => {
        this._container = element;
    };
}

registerLWPComponent("associated-automation-proxy", AssociatedAutomationProxy);
